import type { LineChartReportCardProps } from '../../AnalyticsDashboard.types'
import { useLineChartReportCard } from '../useLineChartReportCard'

const reportId = 'membership_cancelled_members'

export const useMembershipsCancelledMembersReportCard = (): LineChartReportCardProps => {
  return useLineChartReportCard({
    reportId,
    headerLabel: 'Cancelled members',
    headerTooltipTitle: 'Cancelled members',
    headerTooltipDescription: 'Number of members who cancelled their subscriptions.',
  })
}
